<template>
  <div  :class="share == 1 ? 'p50' : ''">
    <div class="attribute">
      <div class="t-top">
        <div class="t-head">
          <!-- <img src="https://picsum.photos/id/729/300/300" alt="" /> -->
          <van-image
            fit="cover"
            width="100%"
            height="100%"
            :src="data.avatar"
            alt=""
          />
        </div>
        <div class="t-name">{{ data.username }}</div>
        <div class="t-lab">
          <div>
            <i class="iconfont icon-gou"></i>
            <span>独家合作</span>
          </div>
          <div>
            <i class="iconfont icon-gou"></i>
            <span>平台认证</span>
          </div>
          <div>
            <i class="iconfont icon-gou"></i>
            <span>交易担保</span>
          </div>
        </div>
      </div>

      <div class="numbers">
        <div>
          <div class="number-num">{{ data.answer }}</div>
          <div class="number-text">解答数</div>
        </div>
        <div class="num-line"></div>
        <div>
          <div class="number-num">{{ data.evaluate }}</div>
          <div class="number-text">评价数</div>
        </div>
        <div class="num-line"></div>
        <div>
          <div class="number-num">{{ data.fans }}</div>
          <div class="number-text">粉丝数</div>
        </div>
      </div>

      <div class="panel">
        <div class="title">
          <div class="title-line"></div>
          <div class="title-text">
            从业年限<span class="">{{ data.year }}年</span>
          </div>
        </div>
        <div class="ad">
          <div v-for="(item, index) in data.keywords" :key="index">
            {{ item }}
          </div>
        </div>

        <div class="title">
          <div class="title-line"></div>
          <div class="title-text">
            擅长领域<span class="">点击查看对应术详解</span>
          </div>
        </div>

        <div class="ly">
          <div v-for="(item, index) in data.modeArr" :key="index">
            {{ item }}
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="chain left-chain">
          <img src="../../../assets/home/connect.png" alt="" />
        </div>
        <div class="chain right-chain">
          <img src="../../../assets/home/connect.png" alt="" />
        </div>

        <div class="title">
          <div class="title-line"></div>
          <div class="title-text">个人介绍</div>
        </div>

        <div class="js-txt">{{ data.introduction }}</div>
        <div class="ls-images">
          <div
            v-for="(img, index) in data.album"
            :key="index"
            v-show="index < 4"
            @click="lookImg(data.album, index)"
          >
            <van-image width="100%" height="100%" fit="cover" :src="img" />
            <div class="ls-img-num" v-if="index > 2">
              <span>共{{ data.album.length }}张</span>
              <i class="iconfont icon-a-LeftArrow"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="panel">
        <div class="chain left-chain">
          <img src="../../../assets/home/connect.png" alt="" />
        </div>
        <div class="chain right-chain">
          <img src="../../../assets/home/connect.png" alt="" />
        </div>

        <div class="title">
          <div class="title-line"></div>
          <div class="title-text">大师案例</div>
        </div>
        <div v-if="teacherCaseRowAll.length != 0" ref="casebox" class="case-box" :class="lookMore ? 'lookMore' : ''">
          <div
            class="case"
            v-for="(item, index) in teacherCaseRowAll"
            :key="index"
          >
            <div class="case-title">{{ item.title }}</div>
            <div class="case-text">
              <p v-html="item.text"></p>
            </div>
          </div>
        </div>

        <div
          class="case"
          style="text-align:center"
          v-if="teacherCaseRow.length == 0"
        >
          暂无案例
        </div>
        <!-- v-if="teacherCaseRowAll.length > 1" -->
        <div class="case-mask" v-if="moreShow"></div>
        <!-- v-if="teacherCaseRowAll.length > 1" -->
        <div
          class="case-more"
          @click="lookMore = !lookMore"
           v-if="moreShow"
        >
          <span>{{ lookMore ? "收起" : "展开" }}</span>
          <i
            class="iconfont icon-list-open"
            :class="lookMore ? 'tranover' : ''"
          ></i>
        </div>
      </div>
    </div>

    <div class="dynamic">
      <div class="title">
        <div class="title-line"></div>
        <div class="title-text">最新动态</div>
      </div>

      <div class="dy-i">
        <div
          v-if="!Array.isArray(data.newCurricula) && data.newCurricula"
          @click="clickVideo()"
        >
          <div class="dy-time">{{ data.newCurricula.created_time }}</div>
          <div class="sp">
            <div class="pos">
              <img :src="data.newCurricula.thumb" alt="" />
              <div class="play">
                <i class="iconfont icon-bofang"></i>
              </div>
            </div>
            <div class="sp-info">
              <div class="sp-title">
                <p>{{ data.newCurricula.title }}</p>
              </div>
              <div class="sp-state">
                <span class="sp-s">{{
                  data.newCurricula.type == 0 ? "免费" : "付费"
                }}</span>
                <span class="eye">
                  <i class="iconfont icon-yanjing"></i>
                  {{ data.newCurricula.readNum }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <!-- <div>
          <div class="dy-time">2020年9月7日 14:23:34</div>
          <div class="wz">
            <div class="wz-pos">
              <img src="https://picsum.photos/id/688/300/300" alt="" />
            </div>
            <div style="flex: 1">
              <div class="wz-title">
                <p>住宅风水最忌讳什么禁忌？办公室门前风水禁忌有哪...</p>
              </div>
              <div class="wz-time">
                <span>1小时前</span>
                <span>已有356人阅读</span>
              </div>
            </div>
          </div>
        </div> -->
        <div v-if="!Array.isArray(data.newCommunity) && data.newCommunity">
          <div class="dy-time">{{ data.newCommunity.created_time }}</div>
          <div>
            <div class="fb-sq">
              <div class="fb-text">{{ data.newCommunity.title }}</div>
              <div class="fb-images">
                <div
                  v-for="(img, index) in data.newCommunity.thumb"
                  :key="index"
                  @click="lookImg(data.newCommunity.thumb, index)"
                >
                  <van-image
                    width="100%"
                    height="100%"
                    fit="cover"
                    :src="img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="evaluate">
      <div class="title">
        <div class="title-line"></div>
        <div class="title-text">
          用户评价<span>({{ data.evaluate || 0 }})</span>
        </div>
      </div>

      <div class="chart">
        <div class="cha">
          <van-circle
            size="80"
            v-model="currentRate"
            :rate="cuRate"
            :speed="100"
            color="#4FD9D5"
            stroke-width="80"
            layer-color="#EFEFEF"
            :text="`${data.cuNum ? data.cuNum : 0}`"
          />
        </div>

        <div class="chart-line"></div>

        <div class="stars">
          <div>
            <span>咨询质量</span>
            <stars :num="data.quality" />
          </div>
          <div>
            <span>服务态度</span>
            <stars :num="data.attitude" />
          </div>
          <div>
            <span>回复速度</span>
            <stars :num="data.speed" />
          </div>
        </div>
      </div>

      <div class="pj">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <comment :list="commentList" :tabshow="true" :state="true" />
        </list>
        <!-- <div class="pl" v-for="item in 3" :key="item">
          <div class="user-info">
            <div class="user-head">
              <img src="https://picsum.photos/id/287/300/300" />
            </div>
            <div class="user-i">
              <p class="user-name">刘德华</p>
              <p class="pl-time">2020.05.28 13:32:05</p>
            </div>
            <div class="cp">
              <p>已购买：<span> 婚姻发展 </span></p>
            </div>
          </div>
          <div class="ly">
            <div>八字</div>
            <div>八字</div>
            <div>八字</div>
          </div>
          <div class="pl-text">
            不是每个人都能成为，自己想要的样子， 但每人，都可以努力，
            成为自己想要的样子。 相信自己，你能作茧自缚，就能破茧成蝶。
          </div>
        </div> -->
      </div>
    </div>

    <div class="footer">
      <div class="f">
        <div class="gz" @click="follow">
          <i
            class="iconfont icon-guanzhu1"
            :style="data.isFollow == 1 ? 'color:#4FD9D5' : ''"
          ></i>
          <span :style="data.isFollow == 1 ? 'color:#4FD9D5' : ''">关注</span>
        </div>
        <div style="flex: 1">
          <div v-if="data" class="foot-btn" :class="data.z_num == -1 ? 'huis' : ''" @click="buyServe">
            {{data.z_num == -1 ? '今日订单已满' : '购买服务'}}
          </div>
        </div>
      </div>
    </div>

    <popup
      v-model="showServe"
      round
      position="bottom"
      :style="{ height: '40%' }"
    >
      <div class="serve-list">
        <div v-for="(item, index) in serveList" :key="index">
          <div class="serve-pos">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="item.thumb"
            />
          </div>
          <div style="flex: 1">
            <div>
              <div class="serve-title">{{ item.title }}</div>
              <div class="serve-text">{{ item.remarks }}</div>
            </div>
            <div class="price-buy">
              <span class="serve-price">￥{{ item.price }}</span>
              <span class="buy-serve" @click="confirmorde(item)">购买服务</span>
            </div>
          </div>
        </div>
      </div>
    </popup>
    <shareBottomComp v-if="share == 1"></shareBottomComp>
  </div>
</template>

<script>
/**
@description:老师详情
@createTime:2021-08-18
@create:wq
*/
import shareBottomComp from "@/components/shareBottomComp";
import { shareJsSdk, HERF, getQueryString } from "@/utils/tool";
import comment from "../../../components/comment.vue";
import stars from "../../../components/stars.vue";
import { Image as VanImage, Toast } from "vant";
import { Circle as VanCircle, List, Popup } from "vant";
export default {
  name: "",
  props: {},
  components: {
    VanImage,
    VanCircle,
    stars,
    comment,
    List,
    Popup,
    shareBottomComp,
  },
  data() {
    return {
      currentRate: 0,
      rate: 100,
      id: "",
      data: "",
      commentList: [],
      loading: false,
      finished: true,
      page: 1,
      showServe: false,
      serveList: [],
      teacherCaseRow: [], //大师案例
      teacherCaseRowAll: [],
      lookMore: false,
      cuRate: 0,
      share: 0,
      moreShow:false
    };
  },
  computed: {},
  watch: {
    lookMore(bf) {
      // if (bf) {
      //   this.teacherCaseRow = this.teacherCaseRowAll;
      // } else {
      //   this.teacherCaseRow = [this.teacherCaseRowAll[0]];
      //   console.log(this.teacherCaseRowAll);
      // }
    },
  },
  mounted() {},
  created() {
    // this.id = this.$route.query.id;
    this.id = this.$route.query.id
      ? this.$route.query.id
      : getQueryString("id");
    if (getQueryString("share")) {
      this.share = 1;
    } else {
      this.share = 0;
    }
    if (this.id) this.teacherDetails(1);
  },
  methods: {
    teacherDetails(ty) {
      this.api.teacherDetails({ id: this.id }).then((res) => {
        this.data = res.data;
        this.data.cuNum = (
          (this.data.quality + this.data.attitude + this.data.speed) /
          3
        ).toFixed(1);
        this.cuRate = (this.data.cuNum / 5) * 100;
        this.teacherCaseRowAll = JSON.parse(
          JSON.stringify(res.data.teacher_case_row)
        );
        this.teacherCaseRow = [];
        if (this.teacherCaseRowAll.length > 1) {
          this.teacherCaseRow.push(this.teacherCaseRowAll[0]);
        } else {
          this.teacherCaseRow = this.teacherCaseRowAll;
        }
        this.lookMore = true
        this.$nextTick(() => {

          // console.log(this.$refs.casebox.offsetHeight);
          let height = this.$refs.casebox.offsetHeight;
          if(height > 300){
            this.lookMore = false;
            this.moreShow = true;
          }else{
            this.lookMore = false;
            this.moreShow = false;
          }
        })
        // console.log(this.teacherCaseRow, 1);
        if (res.data.serviceList && res.data.serviceList.length) {
          this.serveList = res.data.serviceList;
        }
        if (ty == 1) {
          shareJsSdk(
            "teacherDetails",
            this.data.name,
            this.data.introduction,
            this.id,
            this.data.avatar
          );
        }

        this.teacherCommentList();
      });
    },
    teacherCommentList() {
      this.api
        .teacherCommentList({ id: this.id, page: this.page })
        .then((res) => {
          this.commentList = [...this.commentList, ...res.data.data];
          if (res.data.to < res.data.per_page) {
            this.loading = true;
            this.finished = true;
          } else {
            this.loading = false;
            this.finished = false;
          }
        });
    },
    lookImg(imgs, index) {
      this.imagePreview(imgs, index);
    },
    onLoad() {
      this.page++;
      this.teacherCommentList();
    },
    follow() {
      this.api.follow({ id: this.data.uid }).then(() => {
        if (this.data.isFollow == 1) {
          this.data.isFollow = 0;
          this.data.fans--;
          Toast.success("取消成功");
        } else {
          this.data.isFollow = 1;
          this.data.fans++;
          Toast.success("关注成功");
        }
      });
    },
    buyServe() {
      if(this.data.z_num == -1){
        return
      }
      if (this.serveList.length) {
        this.showServe = true;
      } else {
        Toast.success("暂无服务");
      }
    },
    confirmorde(item) {
      localStorage.setItem(
        "order",
        JSON.stringify({
          ...item,
          username: this.data.username,
          avatar: this.data.avatar,
        })
      );
      this.$router.push({ path: "/orderConfirm", query: { s: 1 } });
    },
    clickVideo() {
      this.$router.push({
        path: "/kcdetails",
        query: { id: this.data.newCurricula.id },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
body {
  background: red;
}
.attribute {
  padding: 0.7rem 0 0.26rem;
  background: linear-gradient(135deg, #4fd9d5 0%, #4ecce1 100%);
  .t-top {
    display: flex;
    flex-direction: column;
    align-items: center;
    .t-head {
      width: 1.47rem;
      height: 1.47rem;
      border: 2px solid #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
      border-radius: 50%;
      img {
        width: 100%;
      }
    }
    .t-name {
      font-size: 0.32rem;
      font-weight: bold;
      color: #ffffff;
      margin: 0.2rem 0 0.28rem;
    }
    .t-lab {
      display: flex;
      > div {
        margin: 0 0.1rem;
        font-size: 0.2rem;
        color: #ffffff;

        height: 0.42rem;
        background: rgba($color: #ffffff, $alpha: 0.2);
        border-radius: 0.12rem;
        padding: 0 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 0.22rem;
          color: #ffffff;
          margin-right: 3px;
        }
      }
    }
  }
  .numbers {
    margin: 0.22rem 0.24rem;
    margin-top: 0.36rem;

    height: 1.4rem;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 0.1rem;
    background: rgba($color: #ffffff, $alpha: 0.2);
    display: flex;
    align-items: center;
    .num-line {
      width: 1px;
      height: 0.32rem;
      background: rgba($color: #ffffff, $alpha: 0.4);
    }
    > div:not(.num-line) {
      flex: 1;
    }
    > div {
      text-align: center;
      .number-num {
        font-size: 0.36rem;
        font-weight: bold;
        color: #ffffff;
      }
      .number-text {
        font-size: 0.2rem;
        font-weight: 500;
        color: #ffffff;
        opacity: 0.8;
      }
    }
  }
  .panel {
    margin: 0 0.24rem;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    border-radius: 0.1rem;
    padding: 0.28rem 0;
    margin-bottom: 8px;
    position: relative;
    .chain {
      width: 0.1rem;
      height: 0.5rem;
      position: absolute;
      top: 0;
      transform: translateY(calc(-50% - 4px));
      img {
        width: 100%;
      }
    }
    .left-chain {
      left: 0.08rem;
    }
    .right-chain {
      right: 0.08rem;
    }
    .ad {
      display: flex;
      flex-wrap: wrap;
      margin: 0.1rem 0.34rem;
      margin-bottom: 0.3rem;
      > div {
        width: 1.58rem;
        height: 0.78rem;
        background-image: url("../../../assets/home/ad.png");
        background-size: 1.58rem 0.78rem;
        background-repeat: no-repeat;
        background-position: center;
        font-size: 0.24rem;
        font-weight: 400;
        // line-height: 36px;
        color: #ffffff;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .ly {
      display: flex;
      flex-wrap: wrap;
      margin: 0.2rem 0.36rem;
      > div {
        height: 0.36rem;
        background: #ffeedf;
        border-radius: 0.22rem;

        font-size: 0.2rem;
        font-weight: 400;
        color: #ffa380;
        padding: 0 0.2rem;
        margin-right: 0.1rem;
        margin-bottom: 0.2rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .case-more {
      margin-top: 2px;
      font-size: 0.24rem;
      font-weight: 500;
      color: #4fd9d5;
      display: flex;
      position: absolute;
      bottom: 0.1rem;
      left: 0;
      width: 100%;
      z-index: 3;
      align-items: center;
      justify-content: center;
      i {
        font-size: 12px;
        margin-right: 4px;
        &.tranover {
          transform: rotate(180deg);
        }
      }
    }
    .case-mask {
      height: 0.7rem;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0.6),
        rgba(255,255,255,1)
      );
      position: absolute;
      bottom: 0;
      z-index: 2;
      right: 0;
      left: 0;
    }
    .js-txt {
      font-size: 0.24rem;
      font-weight: 400;
      color: #666666;
      margin: 0.18rem 0.34rem;
    }
    .ls-images {
      margin: 0 0.34rem;

      display: flex;
      > div {
        width: 1.52rem;
        height: 1.72rem;
        border-radius: 0.12rem;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 0.08rem;
        position: relative;
        background: rgba(0, 0, 0, 1);

        .ls-img-num {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background: rgba(0, 0, 0, 0.4);
          font-size: 0.2rem;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          i {
            font-size: 12px;
          }
        }

        img {
          width: 100%;
          //   height: 100%;
        }
      }
    }
    .case {
      margin: 0.18rem 0.34rem;
      .case-title {
        font-size: 0.3rem;
        font-weight: 400;
        color: #4fd9d5;
      }
      .case-text {
        font-size: 0.24rem;
        font-weight: 500;
        color: #666666;
        margin-top: 0.16rem;
        position: relative;
      }
    }
  }
}

.dynamic,
.evaluate {
  margin: 0 0.24rem;
  padding: 0.26rem 0;
  background: #ffffff;
}

.dynamic {
  margin-bottom: 0.12rem;
  .dy-i {
    margin-left: 0.36rem;
    margin-top: 0.34rem;

    > div {
      position: relative;
      &::before {
        content: "";
        width: 0.1rem;
        height: 0.1rem;
        background: #4fd9d5;
        border: 0.02rem solid rgba(79, 217, 213, 0.6);
        border-radius: 50%;
        position: absolute;
        left: -0.36rem;
        top: 0.12rem;
      }

      &::after {
        content: "";
        width: 0.02rem;
        height: 100%;
        background: rgba($color: #4fd9d5, $alpha: 0.2);
        position: absolute;
        left: -0.3rem;
        top: 0.12rem;
      }
      &:last-child::after {
        width: 0;
      }
    }

    .dy-time {
      font-size: 0.28rem;
      color: #999999;
    }

    .sp {
      padding: 0.28rem 0;

      border-radius: 0.28rem;
      overflow: hidden;
      .pos {
        width: 100%;
        height: 3.05rem;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
        }
        .play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          i {
            color: white;
            font-size: 32px;
          }
        }
      }
      .sp-info {
        padding: 0.26rem;
        background: #f5f5f5;
        .sp-title {
          font-size: 0.28rem;
          font-weight: 400;
          color: #333333;
        }
        .sp-state {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .sp-s {
            font-size: 0.24rem;
            font-weight: 400;
            color: #2edb79;
          }

          .eye {
            font-size: 0.24rem;
            font-weight: 400;
            color: #cccccc;
            i {
              color: #999999;
              font-size: 0.27rem;
            }
          }
        }
      }
    }
    .wz {
      //   padding: 0.32rem 0 0.26rem;
      display: flex;
      padding: 0.28rem 0;

      .wz-pos {
        // flex-shrink: 0;
        width: 2.15rem;
        height: 1.62rem;
        border-radius: 8px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 0.32rem;
        img {
          width: 100%;
        }
      }
      .wz-title {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .wz-time {
        margin-top: 0.3rem;
        font-size: 0.24rem;
        font-weight: 300;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .fb-sq {
      .fb-text {
        font-size: 0.28rem;
        font-weight: 400;
        color: #666666;
        margin-top: 0.28rem;
      }
      .fb-images {
        display: flex;
        flex-wrap: wrap;
        margin-top: 2px;
        > div {
          width: 2rem;
          height: 2rem;
          margin-right: 0.06rem;
          margin-bottom: 0.06rem;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}

.evaluate {
  .chart {
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 0.34rem;
    .cha {
    }
    .chart-line {
      width: 1px;
      height: 0.84rem;
      background: #f0f0f0;
    }
    .stars {
      > div {
        display: flex;
        align-items: center;
        margin-bottom: 0.36rem;
        &:last-child {
          margin-bottom: 0;
        }
      }
      span {
        font-size: 0.22rem;
        font-family: PingFang-SC-Medium;
        color: #999999;
        margin-right: 0.18rem;
      }
    }
  }
  .pj {
    margin-top: 0.44rem;
  }
}

.footer {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background: #fafafa;
  .f {
    background: #fafafa;
    position: fixed;
    bottom: 0;
    width: 7.5rem;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    .gz {
      width: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      i {
        color: #666666;
        font-size: 25px;
      }
      span {
        font-size: 12px;
        font-weight: 500;
        color: #999999;
      }
    }
    .foot-btn {
      width: 100%;
      height: 40px;
      background: #4fd9d5;
      &.huis{
        background: #ccc;
        box-shadow: 0 3px 6px rgba($color: #ccc, $alpha: 0.3);
      }
      box-shadow: 0 3px 6px rgba($color: #4fd9d5, $alpha: 0.3);

      font-size: 15px;
      font-weight: 400;
      line-height: 40px;
      text-align: center;
      color: #ffffff;
      border-radius: 20px;
    }
  }
}

.title {
  display: flex;
  align-items: center;
  .title-line {
    width: 0.08rem;
    height: 0.34rem;
    background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
    border-radius: 0px 2px 2px 0px;
    margin-right: 0.26rem;
  }
  .title-text {
    font-size: 0.32rem;
    font-weight: bold;
    color: #666666;
    span {
      font-size: 0.24rem;
      font-weight: 400;
      color: #999999;
      margin-left: 3px;
    }
  }
}
.serve-list {
  > div {
    border-bottom: 1px solid #e3e3e3;
    padding: 0.3rem 0.2rem;
    display: flex;
    .serve-pos {
      width: 1rem;
      height: 1rem;
      border-radius: 0.16rem;
      overflow: hidden;
      margin-right: 0.2rem;
    }
    .serve-title {
      font-size: 0.28rem;
      font-weight: bold;
      color: #333333;
    }
    .serve-text {
      font-size: 0.26rem;
      font-weight: 400;
      color: #666666;
    }
    .price-buy {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;
      .serve-price {
        font-size: 0.28rem;
        font-weight: bold;
        color: #f05468;
      }
      .buy-serve {
        width: 1.6rem;
        height: 0.5rem;
        background: #34c290;
        border-radius: 0.25rem;

        font-size: 0.28rem;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
.case-box{
  height: 300px;
  overflow: hidden;
  &.lookMore{
    height: auto;
    padding-bottom: 0.5rem;
  }
}
</style>
